import axios from 'axios';
import {backendHost} from '../../config';

export const getTransactionById = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/promo/transaction`, {params});
};